import { Paper, Stack } from '@mui/material'
import { Control } from 'react-hook-form'
import { QcStudyDefinitionCreateFormValues } from '../../schemas/StudyAndSeriesDefinitionValidationSchema'
import { QcTimepointContainerSubmission } from '@common/config/api/client'
import { Option } from '@common/components/DynamicTextAutocomplete/DynamicTextAutocomplete'
import { SPACING } from '@common/theme/spacing'
import { SelectField } from '../qc/SelectField'
import { InputField } from '../qc/InputField'

export default function StudyDefinitionForm({
  control,
  qcTimepointContainerSubmissions,
}: {
  control: Control<QcStudyDefinitionCreateFormValues>
  qcTimepointContainerSubmissions: QcTimepointContainerSubmission[]
}) {
  const sourceStudyDescriptions = qcTimepointContainerSubmissions
    .map((qcTimepointContainerSubmission) =>
      qcTimepointContainerSubmission.exam_metadata.map((examMetadata) => ({
        value: examMetadata.exam_metadata_id,
        label: examMetadata.study_description || '',
      })),
    )
    .flat()

  return (
    <Paper
      sx={{
        padding: SPACING.spacingLg,
        borderRadius: SPACING.borderRadiusXxl,
        bgcolor: 'paper.main',
      }}
    >
      <Stack spacing={SPACING.spacingLg}>
        <InputField control={control} name="study_description" label="New study description" />
        <SelectField
          control={control}
          name="exam_metadata_ids"
          label="Source study description"
          options={sourceStudyDescriptions as Option[]}
        />
      </Stack>
    </Paper>
  )
}
